import { ToastContainer, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './toaster.scss'

const defaultOptions: ToastOptions = {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    pauseOnFocusLoss: false,
};
const CustomToast = ({ message }: { message: string }) => {
    return (
        <div className="custom-toast">
            <p>{message}</p>
            {/* <div className="toast-buttons">
                <button className="btn-thank-you" onClick={() => toast.dismiss()}>
                    Thank You
                </button>
                <button className="btn-okay" onClick={() => toast.dismiss()}>
                    Okay
                </button>
            </div> */}
        </div>
    );
};
const Toaster = () => {
    return <ToastContainer />;
};

// Utility functions to show different types of toasts
export const showSuccessToast = (message: string) => {
    toast.success(<CustomToast message={message} />, defaultOptions);
};

export const showErrorToast = (message: string) => {
    toast.error(<CustomToast message={message} />, defaultOptions);
};

export const showInfoToast = (message: string) => {
    toast.info(<CustomToast message={message} />, defaultOptions);
};

export const showWarningToast = (message: string) => {
    toast.warning(<CustomToast message={message} />, defaultOptions);
};

export default Toaster;
